'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Img = require('../../01.atoms/Img/Img.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-related-articles-section',
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col"),
    cnTitle = "".concat(CLASSNAME, "__title");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function RelatedArticlesSection(_ref) {
  var className = _ref.className,
      items = _ref.items,
      title = _ref.title;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, title && /*#__PURE__*/React__default.createElement("h3", null, title), /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, items.map(function (_ref2, i) {
    var title = _ref2.title,
        srcset = _ref2.srcset,
        link = _ref2.link;
    return /*#__PURE__*/React__default.createElement("div", {
      key: i,
      className: cnCol
    }, /*#__PURE__*/React__default.createElement(Link, {
      link: link
    }, /*#__PURE__*/React__default.createElement(Img, {
      srcset: srcset
    }), /*#__PURE__*/React__default.createElement("h4", {
      className: cnTitle
    }, title)));
  })));
}
RelatedArticlesSection.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Item object to be mapped */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    srcset: Img.propTypes.srcset,
    link: PropTypes.string
  })).isRequired,

  /** Title of section */
  title: PropTypes.string
};
RelatedArticlesSection.defaultProps = {
  items: []
};

module.exports = RelatedArticlesSection;
